import { escapeHtml, glyph } from "../lib/util.js";
import {
  getCart,
  setCartQty,
  clearCart,
  expandToRaw,
} from "../lib/cart.js";
import { navigate } from "../lib/router.js";

export function renderCart(els) {
  const lines = getCart();
  if (!lines.length) {
    els.cartPanel.innerHTML = `
      <header class="view-head">
        <h2 class="view-title">Craft cart</h2>
        <p class="view-lead">Queue items from search, farm, or boss prep. Targets persist on this device.</p>
      </header>
      <p class="empty">Cart is empty. Add items from an item page, farm planner, or boss checklist.</p>
    `;
    return;
  }

  const raw = expandToRaw(lines);

  els.cartPanel.innerHTML = `
    <header class="view-head">
      <h2 class="view-title">Craft cart</h2>
      <p class="view-lead">Adjust quantities, then expand to raw materials.</p>
      <div class="action-row">
        <button type="button" class="btn danger" id="clearCart">Clear cart</button>
      </div>
    </header>
    <section class="section">
      <h3 class="section-title">Targets</h3>
      <ul class="stack-list" id="cartLines">
        ${lines
          .map(
            (line) => `
          <li class="stack-card cart-line">
            <button type="button" class="linkish row-name" data-slug="${escapeHtml(line.slug)}">
              ${glyph(line.name, line.colour)}
              <span>${escapeHtml(line.name)}</span>
            </button>
            <label class="qty-label">
              <span class="sr-only">Quantity</span>
              <input type="number" min="0" class="qty-input" data-cart-slug="${escapeHtml(line.slug)}" value="${escapeHtml(line.qty)}" />
            </label>
          </li>`
          )
          .join("")}
      </ul>
    </section>
    <section class="section">
      <h3 class="section-title">Raw materials needed</h3>
      <ul class="check-list">
        ${raw
          .map(
            (r) => `
          <li>
            <button type="button" class="check-row" data-slug="${escapeHtml(r.slug)}">
              ${glyph(r.name, r.colour)}
              <span>${escapeHtml(r.name)}</span>
              <span class="chip-qty">${escapeHtml(r.qty)}×</span>
            </button>
          </li>`
          )
          .join("")}
      </ul>
    </section>
  `;
}

export function bindCart(els) {
  els.cartPanel.addEventListener("click", (e) => {
    if (e.target.closest("#clearCart")) {
      clearCart();
      renderCart(els);
      return;
    }
    const link = e.target.closest("[data-slug]");
    if (link) navigate("item", link.dataset.slug);
  });

  els.cartPanel.addEventListener("change", (e) => {
    const input = e.target.closest("[data-cart-slug]");
    if (!input) return;
    setCartQty(input.dataset.cartSlug, input.value);
    renderCart(els);
  });
}
